/** Ant Design sorter that preserves API row order (header UI only). */
export const SGP_RISK_SERVER_SORTER = { compare: () => 0 };

export const SGP_RISK_SORT_FIELDS = {
  sgpId: "sgp_id",
  sport: "sport",
  league: "league_name",
  totalWagered: "total_wagered",
  pendingVolume: "pending_volume",
  settledVolume: "settled_volume",
  settledPayout: "settled_payout",
  pl: "pl",
  roi: "roi",
  pendingExp: "current_exposure",
  expLimitPct: "exposure_used_percentage",
  pendingExpLimit: "exposure_limit",
};

export const SGP_RISK_COLUMNS = [
  { title: "SGP ID", dataIndex: "sgpId", key: "sgpId", width: 240 },
  { title: "Sport", dataIndex: "sport", key: "sport", width: 140 },
  { title: "League", dataIndex: "league", key: "league", width: 160 },
  {
    title: "Total Volume",
    dataIndex: "totalWagered",
    key: "totalWagered",
    width: 150,
  },
  {
    title: "Pending Volume",
    dataIndex: "pendingVolume",
    key: "pendingVolume",
    width: 150,
  },
  {
    title: "Settled Volume",
    dataIndex: "settledVolume",
    key: "settledVolume",
    width: 160,
  },
  {
    title: "Settled Payout",
    dataIndex: "settledPayout",
    key: "settledPayout",
    width: 150,
  },
  { title: "P/L", dataIndex: "pl", key: "pl", width: 120 },
  { title: "ROI", dataIndex: "roi", key: "roi", width: 100 },
  {
    title: "Pending Exp.",
    dataIndex: "pendingExp",
    key: "pendingExp",
    width: 120,
  },
  {
    title: "% Exp. Limit",
    dataIndex: "expLimitPct",
    key: "expLimitPct",
    width: 140,
  },
  {
    title: "Pending Exp. Limit",
    dataIndex: "pendingExpLimit",
    key: "pendingExpLimit",
    width: 160,
  },
  {
    title: "SGP Adjustment",
    dataIndex: "sgpAdjustment",
    key: "sgpAdjustment",
    width: 170,
  },
];
